import { createElement, memo, useContext, useCallback, useMemo, useEffect, useRef } from '@max/max';
import View from '@hfe/max-view';
import Sensor from '@max/mbc-sensor';
import Text from '@hfe/max-text';
import CitySelector from './components/CitySelector/index';
import ExperienceCard from './components/ExperienceCard/index';
import ViewMoreCard from './components/ViewMoreCard/index';
import { useExperienceData } from './hooks/useExperienceData';
import { SurroundingTypeDesc } from './types/api';
import { setRemConfig, toPx } from '@max/leez-style-util';
import './index.scss';
import BounceScrollView from './components/BounceScrollView';
import { BID_MAP, BID_TYPE } from './constant';
import { navigateToPage } from './utils/navigation';
import Image from "@max/leez-image";
import LinearGradient from '@hfe/max-linear-gradient';
import { useRecommendCityList } from './utils';
const CardWidth = 618;
const CardMargin = 12;
const TripAroundRecommendGuide = (props) => {
    useMemo(() => {
        setRemConfig({
            enabled: true
        });
    }, []);
    const ctx = useContext(global._EngineGlobalContext);
    const { isShowCenterCity = true, autoScrollInterval = 3000, sceneType, cityIdList, cityNameList, customTitle, bgColorStart = '#FFFFFF', bgColorEnd = '#F4F4F4', isShowTitle = true, cityTabBgColor, cityTabSelectedBgColor, cityTabTextColor, cityTabSelectedTextColor, citySelectorPaddingTop = 16, cardBgImageList } = props;
    const bounceScrollViewRef = useRef(null);
    const { error, currentCity, cities, experiences, moreUrl, surroundingType, setCurrentCity, setCurrentGuideIndex } = useExperienceData(isShowCenterCity, ctx, sceneType, cityIdList, cityNameList);
    // 根据 surroundingType 动态生成 title
    // useRecommendCityList 为 false（非 TRAVEL_AROUND_SALE 场景）时，优先使用外部传入的 customTitle
    const title = useRecommendCityList(sceneType) ? `${surroundingType && SurroundingTypeDesc[surroundingType] || '周边'}特色玩法攻略` : customTitle || '特色玩法攻略';
    // 当 experiences 变化时，重置滚动视图到初始状态
    useEffect(() => {
        bounceScrollViewRef.current?.reset?.();
    }, [experiences]);
    /**
     * 计算当前是第几张卡片（从1开始计数）
     * @param currentX 当前滚动的X轴位置
     * @returns 当前卡片索引（从1开始）
     */
    const getCurrentCardIndex = useCallback((currentX) => {
        // 向下取整得到卡片索引（从0开始），然后+1转换为从1开始计数
        const cardIndex = Math.floor((currentX + toPx(24)) / toPx((CardWidth + CardMargin) / 2)) + 1;
        return Math.max(1, cardIndex); // 确保至少返回1
    }, []);
    const lxReport = useCallback((bid, bidType, extraVal) => {
        try {
            const { hotelchannel } = (ctx._runtimeInfo?.queryParams || {});
            const lxCommonParams = {
                hotel_channel: hotelchannel
            };
            const valLab = extraVal ? {
                ...lxCommonParams,
                ...extraVal
            } : lxCommonParams;
            switch (bidType) {
                case BID_TYPE.MV:
                    ctx?._LXReport?.mvReport(bid, {
                        valLab
                    });
                    break;
                case BID_TYPE.MC:
                    ctx?._LXReport?.mcReportWithTag(bid, {
                        valLab
                    });
                    break;
                case BID_TYPE.MC_WITH_TAG:
                    ctx?._LXReport?.mcReportWithTag(bid, {
                        valLab
                    });
                    break;
            }
        }
        catch (error) {
            ctx._raptorReport.reportLog('上报埋点异常', error, {
                category: 'jsError',
                level: 'warn',
                tags: {
                    bid
                }
            });
        }
    }, [ctx]);
    // 监听 currentCity 变化，触发 cityChanged 事件
    useEffect(() => {
        if (currentCity) {
            ctx?._communication?.emit?.('cityChanged', {
                value: currentCity.cityId,
                title: currentCity.cityName
            });
        }
    }, [currentCity, ctx]);
    // if (loading && !currentCity) {
    //   return (
    //     <View className="trip-guide">
    //       <Text className="trip-guide__loading">加载中...</Text>
    //     </View>
    //   );
    // }
    // @ts-ignore
    if (window?.inEditor) {
        return <Image source={{
            uri: 'https://img.meituan.net/makerjiulv/4bc0134786cf6089fdc402a41eef4784273885.png'
        }} style={{
            width: '750rpx',
            height: '451rpx',
            display: 'flex',
            margin: '0 auto'
        }} borderRadius={0}/>;
    }
    if (error) {
        return <View className="trip-guide">
        <Text className="trip-guide__error">加载失败，请稍后重试</Text>
      </View>;
    }
    if (!currentCity || cities.length === 0) {
        return null;
    }
    const boundaryAxisOffset = toPx((experiences.length - 1) * (CardWidth + CardMargin) / 2);
    return <View>
      <Sensor className="trip-guide" once onAppear={() => lxReport(BID_MAP.MODULE_MV, BID_TYPE.MV)}>
        <LinearGradient colors={[bgColorStart, bgColorEnd]} start={{
        x: 0,
        y: 0
    }} end={{
        x: 0,
        y: 1
    }} style={{
        borderTopRightRadius: '24rpx',
        borderTopLeftRadius: '24rpx'
    }}>
        <View className="trip-guide__header">
          <Text x-if={isShowTitle} className="trip-guide__title">{title}</Text>
        </View>

        <CitySelector cities={cities} currentCity={currentCity} onCityChange={setCurrentCity} lxReport={lxReport} paddingTop={citySelectorPaddingTop} cityTabBgColor={cityTabBgColor} cityTabSelectedBgColor={cityTabSelectedBgColor} cityTabTextColor={cityTabTextColor} cityTabSelectedTextColor={cityTabSelectedTextColor}/>

        <View className="trip-guide__cards">
          <BounceScrollView ref={bounceScrollViewRef} boundaryAxisOffset={boundaryAxisOffset} autoScrollInterval={autoScrollInterval} totalCards={experiences.length} onScrollEndDrag={(event) => {
        // 当滚动到末尾时，触发查看更多
        if (event.nativeEvent.contentOffset.x > toPx(((experiences.length - 1) * (CardWidth + CardMargin) + 24) / 2)) {
            if (moreUrl) {
                lxReport(BID_MAP.VIEW_MORE_MC, BID_TYPE.MC, {
                    city_id: currentCity?.cityId
                });
                navigateToPage(moreUrl);
            }
        }
    }} onMomentumScrollEnd={(e) => {
        const cardIndex = getCurrentCardIndex(e.nativeEvent.contentOffset.x);
        setCurrentGuideIndex(cardIndex);
        lxReport(BID_MAP.ITEM_MC, BID_TYPE.MC, {
            city_id: currentCity?.cityId,
            item_index: cardIndex
        });
    }} style={{
        zIndex: 1
    }} className="trip-guide__scroll">
            <Sensor className="trip-guide__cards-list" onAppear={() => lxReport(BID_MAP.RECOMMEND_MV, BID_TYPE.MV, {
        item_names: experiences.map(item => item.playUnifyIdString).join(',')
    })}>
              {experiences.map((item, index) => {
        return <ExperienceCard key={`${currentCity?.cityId}-${item.playUnifyIdString || index}`} item={item} index={index} bgImageList={cardBgImageList?.map(i => i.url)} onAppear={() => lxReport(BID_MAP.ITEM_MV, BID_TYPE.MV, {
            city_id: currentCity?.cityId,
            item_names: item.playUnifyIdString,
            item_index: index
        })}/>;
    })}
              <ViewMoreCard x-if={experiences.length} moreUrl={moreUrl}/>
            </Sensor>
          </BounceScrollView>
          
        </View>
      </LinearGradient>
      </Sensor>
    </View>;
};
export default memo(TripAroundRecommendGuide);
